import { textStyles22 } from './text-styles-2-2';

/**
 * The 2.1 t-shirt scale. Superseded by the numeric 2.2 scale in `text-styles-2-2.ts`; kept while
 * both generations coexist, and deleted — along with this spread — once no call site uses a
 * t-shirt name. The two name sets do not intersect, which is what lets them share one map;
 * `text-styles-2-2.spec.ts` holds that line.
 */
export const textStyles21 = {
  'body-xxl': {
    fontSize: ['3xl', '4xl'],
    lineHeight: ['9', '10'], // TODO: Need a clarification on the mobile line height
    letterSpacing: 'less-tight',
  },
  'body-xl': {
    fontSize: '2xl',
    lineHeight: '8',
    letterSpacing: 'tight',
  },
  'body-lg': {
    fontSize: 'lg',
    lineHeight: '6',
    letterSpacing: 'tight',
  },
  'body-md': {
    fontSize: 'md',
    lineHeight: '6',
    letterSpacing: 'less-tight',
  },
  'body-sm-md': {
    fontSize: 'sm-md',
    lineHeight: '5',
    letterSpacing: 'less-tight',
  },
  'body-sm': {
    fontSize: 'sm',
    lineHeight: '4',
    letterSpacing: 'less-tight',
  },
  'body-xs': {
    fontSize: 'xs',
    lineHeight: '4',
  },
};

export const textStyles = { ...textStyles21, ...textStyles22 };
